import { Picture } from 'src/components/ui/Image'
import { ListingH1 } from 'src/components/plp/ListingH1'

type CollectionBannerProps = {
  imageBannerDesktop?: string
  imageBannerMobile?: string
  enableSession?: boolean
  altText?: string
  h1?: string
  listingName?: string
  showListingH1?: boolean
}

export const CollectionBannerV2 = ({
  imageBannerDesktop,
  imageBannerMobile,
  enableSession,
  altText,
  h1,
  listingName,
  showListingH1,
}: CollectionBannerProps) => {
  if (!enableSession) {
    return null
  }

  const hasImage = Boolean(imageBannerDesktop || imageBannerMobile)
  const headingText = h1?.trim() || listingName || ''

  return (
    <div className="relative flex justify-center items-center overflow-hidden">
      {showListingH1 && hasImage && headingText ? (
        <ListingH1 text={headingText} variant="sr-only" />
      ) : null}
      <Picture
        sources={[
          {
            src: imageBannerMobile ?? '',
            width: 390,
            height: 248,
            media: '(max-width: 600px)',
          },
        ]}
        img={{
          src: imageBannerDesktop ?? '',
          width: 1920,
          height: 517,
          alt: altText ?? 'Imagem do banner da coleção',
          className: 'max-w-full w-full',
          loading: 'eager',
        }}
        shouldCompress={false}
      />

      <div className="absolute inset-x-0 top-[50.87%] bottom-0 bg-gradient-to-t from-[rgba(0,0,0,0.7)] via-[rgba(0,0,0,0.35)] via-1/2 to-[rgba(0,0,0,0)] pointer-events-none" />
    </div>
  )
}
